"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountDeletionStatuses = exports.WorkerJourneyStates = exports.WorkerCategories = exports.genders = void 0;
exports.genders = ['MALE', 'FEMALE', 'OTHER', 'NOT_SHARED'];
exports.WorkerCategories = ['WORKER', 'INTERNAL'];
exports.WorkerJourneyStates = [
    'INTRO',
    'CONFIG',
    'TUTORIAL',
    'TEST_TASK',
    'TEST_TASK_VALIDATION',
    'TEST_TASK_FAILED_END',
    'MAIN_TASK',
    'SUCCESS_END',
    'REFUSED_END',
    'TASK_COMPLETED',
    'EXPIRED_END',
    'SURVEY',
];
exports.accountDeletionStatuses = ['PENDING', 'CANCELLED', 'DELETED'];
//# sourceMappingURL=Workers.js.map